import { render, staticRenderFns } from "./EvaluacionProductividad.vue?vue&type=template&id=00ef88b9"
import script from "./EvaluacionProductividad.vue?vue&type=script&lang=js"
export * from "./EvaluacionProductividad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports